module.exports = __webpack_public_path__ + "static/media/confirm.5efed792.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/confirm.png
// module id = 845
// module chunks = 0